"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedDiscount = exports.manualPaystubType = exports.insuranceType = exports.helocType = exports.helocStatus = exports.documentType = exports.crossSellAppType = exports.coDeedType = exports.coDeedHelocStatusType = exports.assetDepletionType = exports.achAccountType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _profileTypes = require("./profile-types");

var _disclosureTypes = require("./disclosure-types");

var _auditTypes = require("./audit-types");

var _incomeSourceTypes = require("./income-source-types");

var achAccountType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  accountType: _propTypes.default.string,
  accountTypeDescription: _propTypes.default.string,
  routingNumber: _propTypes.default.string,
  accountNumber: _propTypes.default.string,
  ownerName: _propTypes.default.string,
  achAccountId: _propTypes.default.string
});

exports.achAccountType = achAccountType;

var assetDepletionType = _propTypes.default.shape({
  retirement: _propTypes.default.number,
  savings: _propTypes.default.number,
  investment: _propTypes.default.number,
  complete: _propTypes.default.bool
});

exports.assetDepletionType = assetDepletionType;

var crossSellAppType = _propTypes.default.shape({
  crossSellAppId: _propTypes.default.string,
  crossSellAppStatus: _propTypes.default.string,
  crossSellAppType: _propTypes.default.string
});

exports.crossSellAppType = crossSellAppType;

var insuranceType = _propTypes.default.shape({
  floodInsured: _propTypes.default.bool,
  homeownersInsured: _propTypes.default.bool,
  complete: _propTypes.default.bool
});

exports.insuranceType = insuranceType;

var documentType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  type: _propTypes.default.string,
  name: _propTypes.default.string,
  countryCode: _propTypes.default.string,
  description: _propTypes.default.string
});

exports.documentType = documentType;

var manualPaystubType = _propTypes.default.shape({
  completed: _propTypes.default.bool,
  uuid: _propTypes.default.string,
  paystubDocUuid: _propTypes.default.string,
  payFrequency: _propTypes.default.string,
  payDate: _propTypes.default.string
});

exports.manualPaystubType = manualPaystubType;

var selectedDiscount = _propTypes.default.shape({
  type: _propTypes.default.string,
  amount: _propTypes.default.number
});

exports.selectedDiscount = selectedDiscount;

var helocStatus = _propTypes.default.shape({
  avmMatch: _propTypes.default.bool,
  creditFrozen: _propTypes.default.bool,
  creditFrozenWithPin: _propTypes.default.bool,
  creditLocked: _propTypes.default.bool,
  softCreditFico: _propTypes.default.number,
  softCreditNoMatch: _propTypes.default.bool,
  softCreditNoMatchWithSsn: _propTypes.default.bool,
  docVerifyStatus: _propTypes.default.string,
  uwDecision: _propTypes.default.string,
  uwSubDecision: _propTypes.default.string,
  disclosurelistUuid: _propTypes.default.string,
  disclosurelistAppReady: _propTypes.default.bool,
  disclosurelistSummaryReady: _propTypes.default.bool,
  disclosurelistSummaryComplete: _propTypes.default.bool,
  disclosurelistClosingReady: _propTypes.default.bool,
  disclosurelistClosingComplete: _propTypes.default.bool,
  disclosurelistNotaryReady: _propTypes.default.bool,
  disclosurelistNotaryComplete: _propTypes.default.bool,
  giactAccountStatus: _propTypes.default.string,
  manualDeedSigningComplete: _propTypes.default.bool,
  checklistStatus: _propTypes.default.string,
  manualNotary: _propTypes.default.bool,
  pldTaskComplete: _propTypes.default.bool,
  hasAal: _propTypes.default.bool,
  manualDeed: _propTypes.default.bool,
  participantAcceptComplete: _propTypes.default.bool,
  primaryParticipantAcceptComplete: _propTypes.default.bool,
  contextReady: _propTypes.default.bool,
  contextLeadReady: _propTypes.default.bool,
  firstLien: _propTypes.default.bool,
  cancellationStatus: _propTypes.default.string,
  dtiDecline: _propTypes.default.bool,
  creditScoreDecline: _propTypes.default.bool,
  incomeVerificationResultUuid: _propTypes.default.string,
  canIncomeVerify: _propTypes.default.bool,
  manualPayloadUpload: _propTypes.default.bool,
  manualPaystubTasksComplete: _propTypes.default.bool,
  propertyNoMatch: _propTypes.default.bool,
  propertyComplete: _propTypes.default.bool,
  datatreeNoMatch: _propTypes.default.bool,
  datatreeComplete: _propTypes.default.bool,
  plCrossSell: _propTypes.default.bool,
  liensComplete: _propTypes.default.bool,
  liensReady: _propTypes.default.bool,
  showDelinquencyReview: _propTypes.default.bool
});

exports.helocStatus = helocStatus;

var helocType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  loanNumber: _propTypes.default.string,
  amount: _propTypes.default.number,
  reason: _propTypes.default.string,
  reasonDescription: _propTypes.default.string,
  rate: _propTypes.default.number,
  primeRate: _propTypes.default.number,
  term: _propTypes.default.number,
  rateType: _propTypes.default.string,
  payType: _propTypes.default.string,
  idBypass: _propTypes.default.bool,
  income: _propTypes.default.number,
  incomePrimary: _propTypes.default.number,
  incomeCoDeeders: _propTypes.default.number,
  incomeOther: _propTypes.default.number,
  incomeSources: _propTypes.default.arrayOf(_incomeSourceTypes.incomeSourceType),
  documents: _propTypes.default.arrayOf(documentType),
  consents: _propTypes.default.arrayOf(_profileTypes.consentType),
  crossSellApps: _propTypes.default.arrayOf(crossSellAppType),
  disburseAccount: achAccountType,
  autopayAccount: achAccountType,
  plaidAssetsLinkedDate: _propTypes.default.string,
  property: _profileTypes.addressType,
  selectedPropertyUuid: _propTypes.default.string,
  propertyHasExistingMortgage: _propTypes.default.bool,
  propertyListedForSale: _propTypes.default.bool,
  identityReviewed: _propTypes.default.bool,
  coDeedIdentityUuids: _propTypes.default.arrayOf(_propTypes.default.string),
  coDeedStatus: _propTypes.default.string,
  insurance: insuranceType,
  active: _propTypes.default.bool,
  assetDepletion: assetDepletionType,
  incomeVerificationRequestUuid: _propTypes.default.string,
  organization: _propTypes.default.string,
  originationFeePercentage: _propTypes.default.number,
  hasHmda: _propTypes.default.bool,
  hasTShirtSize: _propTypes.default.bool,
  status: helocStatus,
  auditFields: _auditTypes.auditType,
  maritalStatus: _propTypes.default.string,
  requestedManualNotaryTime: _propTypes.default.string,
  requestedManualNotaryAddress: _profileTypes.addressType,
  manualPaystubs: _propTypes.default.arrayOf(manualPaystubType),
  selectedDiscounts: _propTypes.default.arrayOf(selectedDiscount),
  subOrganization: _propTypes.default.string
});

exports.helocType = helocType;

var coDeedType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  name: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    lastName: _propTypes.default.string
  }),
  address: _profileTypes.addressType,
  eConsent: _profileTypes.consentType,
  idDocs: _propTypes.default.arrayOf(documentType),
  email: _propTypes.default.string,
  dob: _propTypes.default.string,
  hasSsn: _propTypes.default.bool
});

exports.coDeedType = coDeedType;

var coDeedHelocStatusType = _propTypes.default.shape({
  helocUuid: _propTypes.default.string,
  active: _propTypes.default.bool,
  deedDocumentUuid: _propTypes.default.string,
  disclosurelistNotaryComplete: _propTypes.default.bool,
  participantAcceptComplete: _propTypes.default.bool,
  disclosureList: _disclosureTypes.disclosurelistType,
  propertyState: _propTypes.default.string
});

exports.coDeedHelocStatusType = coDeedHelocStatusType;